import React from 'react';
import PdfPreviewDialog from '../../../../../Dialog/PdfPreviewDialog/PdfPreviewDialog';
import { SetValues } from '../../../../../../hooks/useForm/useForm';

export type TableRowPdfPreviewActionProps = {
  title: string;
  subtitle?: string;
  baseApiUrl?: string;
  id?: string;
  valueKey?: string;
  apiUrl?: string;
  readUrl?: string;
  readLabel?: string;
  onSuccess?: (data?: SetValues) => void;
  label?: string;
  isOpen?: boolean;
  onClose?: () => void;
  addFileName?: boolean;
};

export const TableRowPdfPreviewAction = ({
  title,
  subtitle,
  id,
  apiUrl,
  readUrl,
  readLabel,
  onSuccess,
  isOpen = false,
  onClose,
  addFileName,
}: TableRowPdfPreviewActionProps) => {
  return (
    <PdfPreviewDialog
      isOpen={isOpen}
      onClose={() => onClose?.()}
      title={title}
      id={id ?? ''}
      apiUrl={apiUrl}
      subtitle={subtitle}
      readUrl={readUrl}
      readLabel={readLabel}
      onSuccess={onSuccess}
      addFileName={addFileName}
    />
  );
};

export default TableRowPdfPreviewAction;
